export default "__VITE_ASSET__BSPkKi66__"